import { css } from "@emotion/react";
import colors from "assets/css/colors";

export default css`
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    border-radius: 6px;
    background-color: ${colors.lightGrey};
  }

  /* Track */
  &::-webkit-scrollbar-track {
    border-radius: 6px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background-color: ${colors.mainBlue};
    border-radius: 6px;
    &:hover {
      background-color: ${colors.darkBlue};
    }
  }
`;
